var _templateObject, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import styled from '@emotion/styled';
import MUISvgIcon, { svgIconClasses } from '@mui/material/SvgIcon';
import * as React from "react";
var SvgIcon = styled(MUISvgIcon)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  &.", " {\n    width: ", ";\n    height: ", ";\n    color: ", ";\n    stroke-width: 1px;\n    vector-effect: non-scaling-stroke;\n  }\n"])), svgIconClasses.root, function (_ref) {
  var size = _ref.size,
    theme = _ref.theme;
  return size && theme.size[size];
}, function (_ref2) {
  var size = _ref2.size,
    theme = _ref2.theme;
  return size && theme.size[size];
}, function (_ref3) {
  var color = _ref3.color,
    theme = _ref3.theme;
  return color && theme.color[color];
});
var SvgTelegram = function SvgTelegram(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#telegram_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19.373 1.62c.03-.58-.443-1.067-1.04-.986-2.188.294-5.683 1.573-9.03 3.038C5.95 5.14 2.715 6.806 1.038 7.895a.86.86 0 0 0-.405.848.96.96 0 0 0 .594.739l4.824 2.036c.211.09.454.055.633-.088l.256-.204C8.559 9.93 10.72 8.2 12.52 6.834a49 49 0 0 1 2.303-1.671q.419-.28.677-.413-.05.084-.12.191c-.208.313-.538.74-.955 1.25-.833 1.018-1.997 2.343-3.192 3.702-.847.964-1.709 1.945-2.475 2.842a.624.624 0 0 0 .037.849l5.591 5.508c.2.197.464.299.721.281a.78.78 0 0 0 .647-.428c.397-.758.806-1.947 1.198-3.36a68 68 0 0 0 1.113-4.773c.678-3.397 1.192-6.98 1.308-9.192",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "telegram_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  }))))));
};
export default SvgTelegram;